import { PipeTransform, Pipe } from '@angular/core';
import { LocalizationService } from '@services/localization.service';
import { UserHelper } from '@helpers/user.helper';
import { environment } from '@environments/environment';
type langConfig = {
  [key: string]: {
    locales: string;
  };
};

type currencyConfig = {
  symbol: string;
  currency: string;
};
@Pipe({ name: 'balanceFormat' })
export class BalanceFormatPipe implements PipeTransform {
  constructor(private _UserHelper: UserHelper, private _LocalizationService: LocalizationService) {}

  langConfig: langConfig = {
    en: {
      locales: 'en-GB',
    },
    tr: {
      locales: 'tr-TR',
    },
    de: {
      locales: 'de-DE',
    },
    nl: {
      locales: 'nl-NL',
    },
    es: {
      locales: 'es-ES',
    },
    fr: {
      locales: 'fr-FR',
    },
    hr: {
      locales: 'hr-HR',
    },
    cs: {
      locales: 'cs-CZ',
    },
    sk: {
      locales: 'sk-SK',
    },
    ru: {
      locales: 'ru-RU',
    },
    pl: {
      locales: 'pl-PL',
    },
    el: {
      locales: 'el-GR',
    },
    fa: {
      locales: 'fa-IR',
    },
    ku: {
      locales: 'ku-IQ',
    },
    vi: {
      locales: 'vi-VN',
    },
    ar: {
      locales: 'ar-SA',
    },
    bg: {
      locales: 'bg-BG',
    },
    da: {
      locales: 'da-DK',
    },
    sr: {
      locales: 'sr-RS',
    },
    pt: {
      locales: 'pt-PT',
    },
    ro: {
      locales: 'ro-RO',
    },
    sq: {
      locales: 'sq-AL',
    },
    mk: {
      locales: 'mk-MK',
    },
    it: {
      locales: 'it-IT',
    },
  };

  currencyConfig: { [key: string]: currencyConfig } = {
    EUR: {
      currency: 'EUR',
      symbol: '€',
    },
    PLN: {
      currency: 'PLN',
      symbol: 'PLN',
    },
    PEN: {
      currency: 'PEN',
      symbol: 'S/.',
    },
    USD: {
      currency: 'USD',
      symbol: '$',
    },
    TRY: {
      currency: 'TRY',
      symbol: 'TL',
    },
    AED: {
      currency: 'AED',
      symbol: 'AED',
    },
    AFN: {
      currency: 'AFN',
      symbol: 'AFN',
    },
    ALL: {
      currency: 'ALL',
      symbol: 'ALL',
    },
    AMD: {
      currency: 'AMD',
      symbol: 'AMD',
    },
    ANG: {
      currency: 'ANG',
      symbol: 'ANG',
    },
    AOA: {
      currency: 'AOA',
      symbol: 'AOA',
    },
    ARS: {
      currency: 'ARS',
      symbol: 'ARS',
    },
    AUD: {
      currency: 'AUD',
      symbol: 'AUD',
    },
    AWG: {
      currency: 'AWG',
      symbol: 'AWG',
    },
    AZN: {
      currency: 'AZN',
      symbol: 'AZN',
    },
    BAM: {
      currency: 'BAM',
      symbol: 'BAM',
    },
    BBD: {
      currency: 'BBD',
      symbol: 'BBD',
    },
    BDT: {
      currency: 'BDT',
      symbol: 'BDT',
    },
    BGN: {
      currency: 'BGN',
      symbol: 'BGN',
    },
    BHD: {
      currency: 'BHD',
      symbol: 'BHD',
    },
    BIF: {
      currency: 'BIF',
      symbol: 'BIF',
    },
    BMD: {
      currency: 'BMD',
      symbol: 'BMD',
    },
    BND: {
      currency: 'BND',
      symbol: 'BND',
    },
    BOB: {
      currency: 'BOB',
      symbol: 'BOB',
    },
    BRL: {
      currency: 'BRL',
      symbol: 'R$',
    },
    BSD: {
      currency: 'BSD',
      symbol: 'BSD',
    },
    BTC: {
      currency: 'BTC',
      symbol: 'BTC',
    },
    BTN: {
      currency: 'BTN',
      symbol: 'BTN',
    },
    BWP: {
      currency: 'BWP',
      symbol: 'BWP',
    },
    BYR: {
      currency: 'BYR',
      symbol: 'BYR',
    },
    BZD: {
      currency: 'BZD',
      symbol: 'BZD',
    },
    CAD: {
      currency: 'CAD',
      symbol: 'CAD',
    },
    CDF: {
      currency: 'CDF',
      symbol: 'CDF',
    },
    CHF: {
      currency: 'CHF',
      symbol: 'CHF',
    },
    CLF: {
      currency: 'CLF',
      symbol: 'CLF',
    },
    CLP: {
      currency: 'CLP',
      symbol: 'CLP',
    },
    CNY: {
      currency: 'CNY',
      symbol: 'CNY',
    },
    COP: {
      currency: 'COP',
      symbol: 'COP',
    },
    CRC: {
      currency: 'CRC',
      symbol: 'CRC',
    },
    CUC: {
      currency: 'CUC',
      symbol: 'CUC',
    },
    CUP: {
      currency: 'CUP',
      symbol: 'CUP',
    },
    CVE: {
      currency: 'CVE',
      symbol: 'CVE',
    },
    CZK: {
      currency: 'CZK',
      symbol: 'CZK',
    },
    DJF: {
      currency: 'DJF',
      symbol: 'DJF',
    },
    DKK: {
      currency: 'DKK',
      symbol: 'DKK',
    },
    DOP: {
      currency: 'DOP',
      symbol: 'DOP',
    },
    DZD: {
      currency: 'DZD',
      symbol: 'DZD',
    },
    EEK: {
      currency: 'EEK',
      symbol: 'EEK',
    },
    EGP: {
      currency: 'EGP',
      symbol: 'EGP',
    },
    ERN: {
      currency: 'ERN',
      symbol: 'ERN',
    },
    ETB: {
      currency: 'ETB',
      symbol: 'ETB',
    },
    FJD: {
      currency: 'FJD',
      symbol: 'FJD',
    },
    FKP: {
      currency: 'FKP',
      symbol: 'FKP',
    },
    GBP: {
      currency: 'GBP',
      symbol: 'GBP',
    },
    GEL: {
      currency: 'GEL',
      symbol: 'GEL',
    },
    GGP: {
      currency: 'GGP',
      symbol: 'GGP',
    },
    GHS: {
      currency: 'GHS',
      symbol: 'GHS',
    },
    GIP: {
      currency: 'GIP',
      symbol: 'GIP',
    },
    GMD: {
      currency: 'GMD',
      symbol: 'GMD',
    },
    GNF: {
      currency: 'GNF',
      symbol: 'GNF',
    },
    GTQ: {
      currency: 'GTQ',
      symbol: 'GTQ',
    },
    GYD: {
      currency: 'GYD',
      symbol: 'GYD',
    },
    HKD: {
      currency: 'HKD',
      symbol: 'HKD',
    },
    HNL: {
      currency: 'HNL',
      symbol: 'HNL',
    },
    HRK: {
      currency: 'HRK',
      symbol: 'HRK',
    },
    HTG: {
      currency: 'HTG',
      symbol: 'HTG',
    },
    HUF: {
      currency: 'HUF',
      symbol: 'HUF',
    },
    IDR: {
      currency: 'IDR',
      symbol: 'IDR',
    },
    ILS: {
      currency: 'ILS',
      symbol: 'ILS',
    },
    IMP: {
      currency: 'IMP',
      symbol: 'IMP',
    },
    INR: {
      currency: 'INR',
      symbol: 'INR',
    },
    IQD: {
      currency: 'IQD',
      symbol: 'IQD',
    },
    IRR: {
      currency: 'IRR',
      symbol: 'IRR',
    },
    ISK: {
      currency: 'ISK',
      symbol: 'ISK',
    },
    JEP: {
      currency: 'JEP',
      symbol: 'JEP',
    },
    JMD: {
      currency: 'JMD',
      symbol: 'JMD',
    },
    JOD: {
      currency: 'JOD',
      symbol: 'JOD',
    },
    JPY: {
      currency: 'JPY',
      symbol: 'JPY',
    },
    KES: {
      currency: 'KES',
      symbol: 'KES',
    },
    KGS: {
      currency: 'KGS',
      symbol: 'KGS',
    },
    KHR: {
      currency: 'KHR',
      symbol: 'KHR',
    },
    KMF: {
      currency: 'KMF',
      symbol: 'KMF',
    },
    KPW: {
      currency: 'KPW',
      symbol: 'KPW',
    },
    KRW: {
      currency: 'KRW',
      symbol: 'KRW',
    },
    KWD: {
      currency: 'KWD',
      symbol: 'KWD',
    },
    KYD: {
      currency: 'KYD',
      symbol: 'KYD',
    },
    KZT: {
      currency: 'KZT',
      symbol: 'KZT',
    },
    LAK: {
      currency: 'LAK',
      symbol: 'LAK',
    },
    LBP: {
      currency: 'LBP',
      symbol: 'LBP',
    },
    LKR: {
      currency: 'LKR',
      symbol: 'LKR',
    },
    LRD: {
      currency: 'LRD',
      symbol: 'LRD',
    },
    LSL: {
      currency: 'LSL',
      symbol: 'LSL',
    },
    LTL: {
      currency: 'LTL',
      symbol: 'LTL',
    },
    LVL: {
      currency: 'LVL',
      symbol: 'LVL',
    },
    LYD: {
      currency: 'LYD',
      symbol: 'LYD',
    },
    MAD: {
      currency: 'MAD',
      symbol: 'MAD',
    },
    MDL: {
      currency: 'MDL',
      symbol: 'MDL',
    },
    MGA: {
      currency: 'MGA',
      symbol: 'MGA',
    },
    MKD: {
      currency: 'MKD',
      symbol: 'MKD',
    },
    MMK: {
      currency: 'MMK',
      symbol: 'MMK',
    },
    MNT: {
      currency: 'MNT',
      symbol: 'MNT',
    },
    MOP: {
      currency: 'MOP',
      symbol: 'MOP',
    },
    MRO: {
      currency: 'MRO',
      symbol: 'MRO',
    },
    MTL: {
      currency: 'MTL',
      symbol: 'MTL',
    },
    MUR: {
      currency: 'MUR',
      symbol: 'MUR',
    },
    MVR: {
      currency: 'MVR',
      symbol: 'MVR',
    },
    MWK: {
      currency: 'MWK',
      symbol: 'MWK',
    },
    MXN: {
      currency: 'MXN',
      symbol: 'MXN',
    },
    MYR: {
      currency: 'MYR',
      symbol: 'MYR',
    },
    MZN: {
      currency: 'MZN',
      symbol: 'MZN',
    },
    NAD: {
      currency: 'NAD',
      symbol: 'NAD',
    },
    NGN: {
      currency: 'NGN',
      symbol: 'NGN',
    },
    NIO: {
      currency: 'NIO',
      symbol: 'NIO',
    },
    NOK: {
      currency: 'NOK',
      symbol: 'NOK',
    },
    NPR: {
      currency: 'NPR',
      symbol: 'NPR',
    },
    NZD: {
      currency: 'NZD',
      symbol: 'NZD',
    },
    OMR: {
      currency: 'OMR',
      symbol: 'OMR',
    },
    PAB: {
      currency: 'PAB',
      symbol: 'PAB',
    },
    PGK: {
      currency: 'PGK',
      symbol: 'PGK',
    },
    PHP: {
      currency: 'PHP',
      symbol: 'PHP',
    },
    PKR: {
      currency: 'PKR',
      symbol: 'PKR',
    },
    PYG: {
      currency: 'PYG',
      symbol: 'PYG',
    },
    QAR: {
      currency: 'QAR',
      symbol: 'QAR',
    },
    RON: {
      currency: 'RON',
      symbol: 'RON',
    },
    RSD: {
      currency: 'RSD',
      symbol: 'RSD',
    },
    RUB: {
      currency: 'RUB',
      symbol: 'RUB',
    },
    RWF: {
      currency: 'RWF',
      symbol: 'RWF',
    },
    SAR: {
      currency: 'SAR',
      symbol: 'SAR',
    },
    SBD: {
      currency: 'SBD',
      symbol: 'SBD',
    },
    SCR: {
      currency: 'SCR',
      symbol: 'SCR',
    },
    SDG: {
      currency: 'SDG',
      symbol: 'SDG',
    },
    SEK: {
      currency: 'SEK',
      symbol: 'SEK',
    },
    SGD: {
      currency: 'SGD',
      symbol: 'SGD',
    },
    SHP: {
      currency: 'SHP',
      symbol: 'SHP',
    },
    SLL: {
      currency: 'SLL',
      symbol: 'SLL',
    },
    SOS: {
      currency: 'SOS',
      symbol: 'SOS',
    },
    SRD: {
      currency: 'SRD',
      symbol: 'SRD',
    },
    STD: {
      currency: 'STD',
      symbol: 'STD',
    },
    SVC: {
      currency: 'SVC',
      symbol: 'SVC',
    },
    SYP: {
      currency: 'SYP',
      symbol: 'SYP',
    },
    SZL: {
      currency: 'SZL',
      symbol: 'SZL',
    },
    THB: {
      currency: 'THB',
      symbol: 'THB',
    },
    TJS: {
      currency: 'TJS',
      symbol: 'TJS',
    },
    TMT: {
      currency: 'TMT',
      symbol: 'TMT',
    },
    TND: {
      currency: 'TND',
      symbol: 'TND',
    },
    TOP: {
      currency: 'TOP',
      symbol: 'TOP',
    },
    TTD: {
      currency: 'TTD',
      symbol: 'TTD',
    },
    TWD: {
      currency: 'TWD',
      symbol: 'TWD',
    },
    TZS: {
      currency: 'TZS',
      symbol: 'TZS',
    },
    UAH: {
      currency: 'UAH',
      symbol: 'UAH',
    },
    UGX: {
      currency: 'UGX',
      symbol: 'UGX',
    },
    UYU: {
      currency: 'UYU',
      symbol: 'UYU',
    },
    UZS: {
      currency: 'UZS',
      symbol: 'UZS',
    },
    VEF: {
      currency: 'VEF',
      symbol: 'VEF',
    },
    VND: {
      currency: 'VND',
      symbol: 'VND',
    },
    VUV: {
      currency: 'VUV',
      symbol: 'VUV',
    },
    WST: {
      currency: 'WST',
      symbol: 'WST',
    },
    XAF: {
      currency: 'XAF',
      symbol: 'XAF',
    },
    XAG: {
      currency: 'XAG',
      symbol: 'XAG',
    },
    XAU: {
      currency: 'XAU',
      symbol: 'XAU',
    },
    XCD: {
      currency: 'XCD',
      symbol: 'XCD',
    },
    XDR: {
      currency: 'XDR',
      symbol: 'XDR',
    },
    XOF: {
      currency: 'XOF',
      symbol: 'XOF',
    },
    XPD: {
      currency: 'XPD',
      symbol: 'XPD',
    },
    XPF: {
      currency: 'XPF',
      symbol: 'XPF',
    },
    XPT: {
      currency: 'XPT',
      symbol: 'XPT',
    },
    YER: {
      currency: 'YER',
      symbol: 'YER',
    },
    ZAR: {
      currency: 'ZAR',
      symbol: 'ZAR',
    },
    ZMK: {
      currency: 'ZMK',
      symbol: 'ZMK',
    },
    ZMW: {
      currency: 'ZMW',
      symbol: 'ZMW',
    },
  };

  currencyFilterAction(): string {
    const currencyCodeFilter = Object.values(this.currencyConfig).filter(
      (i: currencyConfig) => i.symbol === (this._UserHelper.isSignedIn ? this._UserHelper.customerUser.Symbol : environment.currencySymbol)
    );
    if (currencyCodeFilter.length === 1) {
      return currencyCodeFilter[0].currency;
    }

    return this.currencyConfig.EUR.currency;
  }

  langControlAction(lang?: string): string {
    return this.langConfig[lang ? lang : this._LocalizationService.LANGCODE || 'en-GB'].locales;
  }

  formatCurrency(amount: any, lang?: string) {
    let balance: number;
    if (isNaN(amount)) {
      try {
        if (typeof amount === 'string') {
          let a = amount.split(' ')[0];
          // if (a.includes('PLN') || a.includes('€') || a.includes('S/.')) {
          //   a = a.replace(/\s*(PLN|€|S\/\.)$/g, '');
          // }
          if (a.substring(a.length - 3, a.length - 2) === ',') {
            a = a.replace(/\./g, '').replace(/,/g, '.');
          } else {
            a = a.replace(/,/g, '');
          }

          balance = Number(a);
        }
      } catch (err) {
        console.error('balancePipe', err);
      }
    } else {
      balance = amount;
    }

    const result = new Intl.NumberFormat(this.langControlAction(lang), { style: 'currency', currency: this.currencyFilterAction(), currencyDisplay: 'symbol' }).format(balance);
    return result;
  }

  transform(value: any, lang?: string): any {
    if (value || value === 0 || value === '0') {
      return this.formatCurrency(value, lang);
    } else {
      return value;
    }
  }
}

@Pipe({ name: 'cashoutBalance' })
export class CashoutBalance implements PipeTransform {
  transform(value: any): any {
    if (typeof value === 'string') {
      return parseFloat(value);
    } else return value;
  }
}
